export default "__VITE_ASSET__DhV5KT53__"